module.exports = __webpack_public_path__ + "img/Unidad11-4.6f58f347.png";